import styled from 'styled-components'


export const VideoWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 100px 0px;
    height: flex;
    position: relative;
    z-index: 1;
    width: 80%;
`;

export const ReactPlayer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
`;